module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Norah Gaughan, Margery Winter, Berroco Design Team, Thayer Allyson Gowdy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Norah Gaughan, author of STC’s "), _c('I', [_vm._v("Knitting Nature")]), _vm._v(" and "), _c('I', [_vm._v("Comfort Knitting & Crochet: Afghans")]), _vm._v(", is Berroco’s design director; her work has been published by almost all of the major yarn companies and knitting magazines in the industry. She lives in New Hampshire.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TcZtCy/images/cover.jpg?1697492716224",
      "alt": "This image is the cover for the book Comfort Crocheted Afghans"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Comfort Crocheted Afghans\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Brighten your home—or brighten a loved one’s day—with these clear instructions for creating three cozy, colorful afghans.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" For many of us, afghans are the epitome of comfort. Colorful and inviting, they are a staple of the home, without which a living room or bedroom just wouldn’t feel complete. And whether you’re making one for yourself, as a housewarming gift, or to welcome a new baby into the world, the process of creating a handmade afghan can be as rewarding as the finished product. This sampler from "), _c('i', [_vm._v("Comfort Knitting & Crochet: Afghans")]), _vm._v(" is intended for crocheters of every skill level, and brings new life to the well-loved and versatile afghan.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Stewart, Tabori & Chang\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0